// extracted by mini-css-extract-plugin
module.exports = {"notEnoughSpaceWarningContainer":"SpaceWarningLabel_notEnoughSpaceWarningContainer__1p7nv","notEnoughSpaceWarningLabel":"SpaceWarningLabel_notEnoughSpaceWarningLabel__1sKbx"};